import { CargoItemForm } from 'components/common/cargo-item-form';
import type { IWhTaskItemsAddFormProps } from './types';

export const WhTaskItemsAddForm = (props: IWhTaskItemsAddFormProps) => {
  const { form, formId, onFinish } = props;

  return <CargoItemForm form={form} formId={formId} name='warehouseTaskItems' withoutStack onFinish={onFinish} />;
};
